import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface Location {
  name: string;
  distance: string;
  time: string;
  icon: string;
  image: string;
  alt: string;
}

export default function LocationHighlights() {
  const keyLocations: Location[] = [
  {
    name: 'IIM Bangalore',
    distance: '160 m',
    time: '1 min',
    icon: 'AcademicCapIcon',
    image: "/assets/images/Screenshot_2026-01-06_062250-1767661278716.png",
    alt: 'IIM Bangalore entrance with students and campus architecture'
  },
  {
    name: 'Corporate Tech Hubs',
    distance: '850 m',
    time: '4 min drive',
    icon: 'BuildingOfficeIcon',
    image: "/assets/images/HSBC-Bangalore-Bannerghatta-Road-1782646724659.jpg",
    alt: 'HSBC Bangalore Bannerghatta Road corporate office building'
  },
  {
    name: 'Bannerghatta Road',
    distance: '300 mtrs',
    time: '3 mins',
    icon: 'MapPinIcon',
    image: "/assets/images/images-1782647594285.jpg",
    alt: 'Aerial night view of Bannerghatta Road with city lights and traffic'
  },
  {
    name: 'Upcoming Metro Station',
    distance: '800 m',
    time: '10 mins walk',
    icon: 'MapIcon',
    image: "/assets/images/_DSC8572-1782647181660.jpg",
    alt: 'Upcoming metro station near Proximus serviced apartments'
  }];


  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl lg:text-5xl font-display font-bold text-primary mb-4">
            Proximity to What Matters
          </h2>
          <p className="text-lg text-text-secondary">Strategically located in South Bangalore's premium hub, putting you minutes away from everything important 

          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {keyLocations.map((location, index) =>
          <div
            key={index}
            className="group bg-card rounded-xl overflow-hidden hover:shadow-premium transition-all duration-300 hover:-translate-y-1">

              <div className="relative h-48 overflow-hidden">
                <AppImage
                src={location.image}
                alt={location.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute inset-0 bg-gradient-to-t from-primary/80 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center space-x-2 text-white">
                    <Icon name={location.icon as any} size={20} />
                    <span className="font-semibold">{location.name}</span>
                  </div>
                </div>
              </div>
              <div className="p-4 space-y-2">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-text-secondary">Distance</span>
                  <span className="font-semibold text-primary">{location.distance}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-text-secondary">Travel Time</span>
                  <span className="font-semibold text-accent">{location.time}</span>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-12 text-center">
          <a
            href="/location-guide"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-primary hover:bg-primary/90 text-white font-semibold rounded-lg transition-all duration-300 hover:scale-105">

            <span>Explore Full Location Guide</span>
            <Icon name="ArrowRightIcon" size={20} className="text-white" />
          </a>
        </div>
      </div>
    </section>);

}